import voicePreferenceClasses from './ccf-voice-preference.module.scss';
import { Grid, Hidden } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import Footer from '../login/footer/footer';
import { Box, FormControl, Card, CardContent, CardHeader } from '@mui/material';

import {
  voicePreferenceActions,
  selectVoicePrefernceState,
  selectVoicePrefernceBtnState,
  selectVoicePrefInputState,
  selectVoicePrefCheckboxState,
  selectVoicePrefErrorState,
  navigateToDashboard,
  selectVoicePrefRedirectState,
} from '../ccf-voice-preference/agentSessionSlice';

import {
  CcfAgentDashboardIcon,
  CcfButton,
  CcfCheckbox,
  CcfCxoneLogoIcon,
  CcfRadioHighlight,
  CcfTextField,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useEffect, useState } from 'react';
import { CXoneAuth } from '@nice-ccf/agent-sdk';
import { MarketingPanel } from '../login/marketing-panel/marketing-panel';
import { globalActions } from '../global.app.slice';
import { isEternalsEnv } from '../../util/common';

/* eslint-disable-next-line */
export interface CcfVoicePreferenceProps {
  consumerAppName?: string;
  sessionConsumerCallback?(message: string, sessionType: string): void;
}

/**
 * Component used for ccf voice preference
 * @param props - CcfVoicePreferenceProps
 * @example <CcfVoicePreference />
 * @returns
 */
export function CcfVoicePreference(props: CcfVoicePreferenceProps) {
  const dispatch = useDispatch();
  const history = useHistory();
  const radioButtonState = useSelector(selectVoicePrefernceState);
  const buttonState = useSelector(selectVoicePrefernceBtnState);
  const inputBoxState = useSelector(selectVoicePrefInputState);
  const checkboxState = useSelector(selectVoicePrefCheckboxState);
  const error = useSelector(selectVoicePrefErrorState);
  const redirectToDashboard = useSelector(selectVoicePrefRedirectState);
  const [translate] = useTranslator();
  const voicePreferences = translate('voicePreferences');
  const voiceConnection = translate('voiceConnection');
  const agent = translate('Agent');
  const [inputError, setInputError] = useState('');
  const {
    setVoicePrefInputText,
    checkVoicePrefRadioSelection,
    setCheckBoxSelection,
    isWebRTCEnabled,
    setAgentSession,
  } = voicePreferenceActions;
  const { setAuthenticationStage } = globalActions;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth > 600 && window.innerWidth <= 1024
  );
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  useEffect(() => {
    /**
     * Function to handle screen resize
     * @example - handleResize(e)
     */
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
      setIsTablet(window.innerWidth > 600 && window.innerWidth <= 1024);
      setIsDesktop(window.innerWidth > 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //  useEffect(() => {
  //    const cxoneAuthInstance = CXoneAuth.instance;
  //    cxoneAuthInstance.reInitializeAuthFlow();
  //  }, []);

  //  useEffect(() => {
  //    dispatch(isWebRTCEnabled(props.consumerAppName));
  //  }, [isWebRTCEnabled]);

  /**
   * Function to handle voice preference button click
   * @param e - React.SyntheticEvent
   * @example handleVoicePrefBtnClick(e)
   */
  const handleVoicePrefBtnClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    //Phone Number and station Id validation
    if (radioButtonState.defaultSelected === 'phone') {
      /^[0-9]{10}$/.test(inputBoxState.enteredVoicePrefInput)
        ? startAgentSession()
        : setInputError('Inavlid Phone Number');
    } else if (radioButtonState.defaultSelected === 'stationId') {
      /^[0-9]{4}$/.test(inputBoxState.enteredVoicePrefInput)
        ? startAgentSession()
        : setInputError('Inavlid Station ID');
    } else {
      startAgentSession();
    }
  };

  /**
   * Function to initiate the agent session and navigate to dashboardF
   * @example - startAgentSession()
   */
  const startAgentSession = () => {
    setInputError('');
    if (!isEternalsEnv()) {
      dispatch(setAuthenticationStage(3));
    }
    dispatch(globalActions.renderVoicePrefPage(false));
  };

  /**
   * Function to handle radio button change
   * @param e - React.ChangeEvent<HTMLInputElement>
   * @example - handleRadioButtonChange(e)
   */
  const handleRadioButtonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setInputError('');
    dispatch(checkVoicePrefRadioSelection(e.target.value));
    localStorage.setItem('voicePreferenceRememberOption', 'true');
  };

  /**
   * Function to handle voice preference input change
   * @param e - React.ChangeEvent<HTMLInputElement>
   * @example - handleVoicePrefInputChange(e)
   */
  const handleVoicePrefInputChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    e.preventDefault();
    setInputError('');
    dispatch(setVoicePrefInputText(e.target.value));
  };

  /**
   * Function to handle chaneckbox change
   * @param e - React.ChangeEvent<HTMLInputElement>
   * @example - handleCheckboxChange(e)
   */
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    dispatch(setCheckBoxSelection(e.target.checked));
  };

  return (
    <div className={voicePreferenceClasses['voicePrefernceParent']}>
      <Grid container className="heightInherit">
        <Grid item lg={isDesktop ? 8 : 12} md={12} xs={12} sm={12}>
          <Box className="loginContainer">
            {/* <Hidden mdDown> */}
            <Box>
              <CcfCxoneLogoIcon
                style={{
                  fill: '#ffff',
                  width: '150px',
                  height: '70px',
                }}
              />
            </Box>
            <Card
              variant="outlined"
              className={voicePreferenceClasses.cardWrapper}
            >
              <Box
                display={'flex'}
                className={voicePreferenceClasses.cardHeaderBox}
              >
                <Box>
                  <CcfAgentDashboardIcon />
                </Box>
                <CcfTypography
                  variant="body1"
                  className={voicePreferenceClasses.cardHeader}
                >
                  {agent}
                </CcfTypography>
              </Box>
              <hr className={voicePreferenceClasses.dividerLine} />
              <div
                className={voicePreferenceClasses.cardHeaderBox}
                style={{ paddingTop: '16px' }}
              >
                {' '}
                {voiceConnection}{' '}
              </div>
              <CardContent className="voicePrefCardWrapper">
                <div className="preferenceSelectorContainer">
                  <CcfRadioHighlight
                    options={radioButtonState}
                    onRadioButtonSelection={handleRadioButtonChange}
                  ></CcfRadioHighlight>
                  <CcfTextField
                    id="voice_Preferance_val"
                    placeholder={
                      radioButtonState.defaultSelected !== 'phone'
                        ? translate('stationId')
                        : translate('phoneNumber')
                    }
                    size="small"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    variant="outlined"
                    fullWidth={true}
                    value={inputBoxState.enteredVoicePrefInput}
                    onChange={handleVoicePrefInputChange}
                    helperText={inputError && inputError}
                    error={inputError.length > 0}
                    style={{
                      display:
                        radioButtonState.defaultSelected === 'softPhone'
                          ? 'none'
                          : 'block',
                    }}
                    className={voicePreferenceClasses.textFieldStyling}
                  />
                  <div className={'rememberWrapper'}>
                    <CcfCheckbox
                      options={checkboxState}
                      onCheckboxChange={handleCheckboxChange}
                    ></CcfCheckbox>
                  </div>
                  <div className={'buttonWrapper'}>
                    <CcfButton
                      id="launchBtn"
                      variant="contained"
                      color="primary"
                      disabled={buttonState.buttonDisabled}
                      fullWidth={true}
                      disableElevation
                      className={
                        buttonState.buttonDisabled
                          ? 'primaryButtonDisabledStyle'
                          : 'primaryButtonStyling'
                      }
                      onClick={handleVoicePrefBtnClick}
                    >
                      <CcfTypography translationKey="launch" />
                    </CcfButton>
                  </div>
                </div>
              </CardContent>
            </Card>
            {/* <Hidden mdDown> */}
            <Footer />
            {/* </Hidden> */}
          </Box>
        </Grid>
        <Hidden mdDown>
          {isDesktop && (
            <Grid
              item
              lg={4}
              md={6}
              display={{ xs: 'none', sm: 'none', md: 'none', lg: 'block' }}
            >
              <MarketingPanel />
            </Grid>
          )}
        </Hidden>
      </Grid>
    </div>
  );
}

export default CcfVoicePreference;
